import React from 'react'
import PropTypes from 'prop-types'

import { IntegrationPartnerProvider } from '@termly-web/common'

import Config from 'config'

import { useAuth } from 'pkg/authentication'


export default function DashboardIntegrationProvider({ children }) {
  const { user } = useAuth()

  // At some point, we might have other integration partners to deal
  // with, but for right now we only have one (Duda), so I'm KISSing
  // this and just treating it as a boolean for now.
  const isIntegrationPartner = Boolean(user.integration_partner)

  return (
    <IntegrationPartnerProvider
      domain={ Config.DOMAIN }
      isIntegrationPartner={ isIntegrationPartner }
    >
      { children }
    </IntegrationPartnerProvider>
  )
}

DashboardIntegrationProvider.propTypes = {
  children: PropTypes.node,
}
